import styled from 'styled-components';

export const QueryItemStyle = styled.li`
  box-shadow: ${(props) => props.isHovered ? '1px 1px 6px 1px rgba(19, 78, 117, 1)' : 'grey'};
  /* "linear-gradient(to right, #020d39, #012e58, #134e75, #307190, #5394a9); */
  height: 40px;
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 12px
  border-radius: 2px;
  background-color: #f1f1f1;
  padding: 3px 9px 0px;
  vertical-align: top;
`

export const ListItem = styled.p`
  display: inline-block;
  cursor: default;
  margin: 0px;
  font-family: Avenir-Roman;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: #4a4a4a;
`

export const CloseButton = styled.button`
  display: inline-block;
  background-color: Transparent;
  border: none;
  padding: 0px;
  margin: 0px 0px 0px 6px;
`
